var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUnpinned(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    xmlns: "http://www.w3.org/2000/svg",
    width: 27.5,
    height: 40,
    viewBox: "0 0 27.5 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M.87726-7.91357C-4.22333-7.91357-8.37274-3.76416-8.37274,1.33643V6.72522H10.12726V1.33643C10.12726-3.76416,5.97784-7.91357,.87726-7.91357Z",
    fill: "none"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "b",
    d: "M18.65214,23.0986L5.31137,15.39856c-1.61483-.9831-3.72086-.47098-4.70396,1.14385s-.47098,3.72086,1.14385,4.70396c.04505,.02742,.09072,.0538,.13698,.07911l13.33917,7.70324c1.65306,.91735,3.7368,.32094,4.65414-1.33213,.89495-1.6127,.35131-3.64451-1.22942-4.5948v-.0032ZM7.64888,14.77021l10.37651,5.99087,3.52865-9.82171-7.16283-4.13621-6.74073,7.96545-.0016,.0016ZM0,40l9.92564-12.0569-4.44639-2.56774L0,40ZM25.84374,5.5081L16.95096,.36941c-1.21432-.73247-2.7925-.34186-3.52497,.87246-.73247,1.21432-.34186,2.7925,.87246,3.52498,.02794,.01685,.0562,.03317,.08477,.04895l8.89438,5.14669c1.19446,.76443,2.78245,.41582,3.54688-.77864,.76443-1.19446,.41582-2.78245-.77864-3.54688-.06809-.04357-.13819-.08391-.21008-.12087l.00799-.00799Z",
    fill: "current"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnpinned);
export default __webpack_public_path__ + "static/media/unpinned.2f9bab9170edfa56f82bd64f77b25c8d.svg";
export { ForwardRef as ReactComponent };